import { Subtitle } from "@finanedi.es/front/common/atoms"

export const TLeyAntifraudeFormHeader = () => {
  return (
    <div className='fs-col-span-12 fs-border-t fs-border-gray-200 fs-border-solid fs-py-2'>
      <Subtitle
        className='fs-text-sm fs-font-medium'
        text='1- Genera el documento si es necesario'
      />
    </div>
  )
}
